<template>
  <div >
    <el-input
      type='textarea'
      v-model="child_defaultValue"
      :placeholder="fieldArguments.placeholder"
      @change="onChange"
    ></el-input>
  </div>
</template>

<script>
  import Common from './js/Common'
  import InputTextarea from './js/InputTextarea'


  export default {
    name: 'sls-textarea',
    mixins:[Common],
    data () {
      return {
        inital_defaultValue:'',
        child_defaultValue:'',
      }
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/solely-fields/SlsTextarea.vue